import { StatusType } from "~/components/status-request/types";

export const STATUS_ICON = {
  [StatusType.success]: "IconCheck",
  [StatusType.failed]: "IconInfo",
};
